/**
 * Sending user feedback to the team.
 *
 * The endpoint lives in the auth service because that is where SES is already
 * configured; this branch has no accounts, so nothing is sent about who the
 * person is beyond the address they choose to type.
 */

import axios from 'axios';

const AUTH_URL =
  process.env.REACT_APP_AUTH_URL ||
  'https://snnzcfq3kr7q2qi2ikoo7n3un40jlczv.lambda-url.us-east-1.on.aws/';

const TIMEOUT = 15000;

export async function sendFeedback({ message, email, profile }) {
  const { data } = await axios.post(
    `${AUTH_URL}feedback`,
    {
      message,
      email,
      profile,
      page: typeof window !== 'undefined' ? window.location.href : '',
    },
    { timeout: TIMEOUT }
  );
  return data;
}
